<div
  class="bg-gradient-to-r from-primary-200 via-primary-300 to-primary-400 pt-1 pb-1.5 border border-primary-100 relative z-[12]"
>
  <div class="container flex items-center gap-4 py-1 justify-end">
    <!-- <a routerLink="/driver" [ngClass]="TextSizeMap.label.sm.default"
      class="flex items-center gap-2 rounded-md transition-all duration-300 group !text-white hover:opacity-70">
      <ng-icon [ngClass]="TextSizeMap.p.xl.default" name="ionSettingsOutline"></ng-icon>
      <p class="text-inherit">Driver</p>
    </a>
    <a routerLink="/fleet" [ngClass]="TextSizeMap.label.sm.default"
      class="flex items-center gap-2 rounded-md transition-all duration-300 group !text-white hover:opacity-70">
      <ng-icon [ngClass]="TextSizeMap.p.xl.default" name="ionSettingsOutline"></ng-icon>
      <p class="text-inherit">Fleet</p>
    </a>
    <a routerLink="/user" [ngClass]="TextSizeMap.label.sm.default"
      class="flex items-center gap-2 rounded-md transition-all duration-300 group !text-white hover:opacity-70">
      <ng-icon [ngClass]="TextSizeMap.p.xl.default" name="ionSettingsOutline"></ng-icon>
      <p class="text-inherit">Passenger</p>
    </a>
    <a routerLink="/admin" [ngClass]="TextSizeMap.label.sm.default"
      class="flex items-center gap-2 rounded-md transition-all duration-300 group !text-white hover:opacity-70">
      <ng-icon [ngClass]="TextSizeMap.p.xl.default" name="ionSettingsOutline"></ng-icon>
      <p class="text-inherit">Admin</p>
    </a> -->
    @if (!keycloakCustomService.isLoggedIn()) {
      <a
        routerLink="/login"
        [ngClass]="TextSizeMap.label.sm.default"
        class="flex items-center gap-2 rounded-md transition-all duration-300 group !text-white hover:opacity-70"
      >
        <ng-icon
          [ngClass]="TextSizeMap.p.xl.default"
          name="ionLogInOutline"
          class=""
        />
        <p class="text-inherit">Login</p>
      </a>
      <a
        routerLink="/sign-up"
        [ngClass]="TextSizeMap.label.sm.default"
        class="flex items-center gap-2 rounded-md transition-all duration-300 group !text-white hover:opacity-70"
      >
        <ng-icon
          [ngClass]="TextSizeMap.p.lg.default"
          name="ionPersonAddOutline"
          class=""
        />
        <p class="text-inherit">Register</p>
      </a>
    } @else {
      <a
        [routerLink]="getDashboardLink()"
        [ngClass]="TextSizeMap.label.sm.default"
        class="flex items-center gap-2 rounded-md transition-all duration-300 group !text-white hover:opacity-70"
      >
        <ng-icon
          [ngClass]="TextSizeMap.p.xl.default"
          name="ionLogInOutline"
          class=""
        />
        <p class="text-inherit capitalize">{{ userName() }}</p>
      </a>
      <a
        (click)="logout()"
        [ngClass]="TextSizeMap.label.sm.default"
        class="flex items-center gap-2 rounded-md transition-all duration-300 group !text-white hover:opacity-70"
      >
        <ng-icon
          [ngClass]="TextSizeMap.p.lg.default"
          name="ionPersonAddOutline"
          class=""
        />
        <p class="text-inherit">Logout</p>
      </a>
    }
  </div>
</div>
